import request from "../utils/request";

/** 報表與分析（Velocity / Burndown / EVM / CFD / Throughput / Aging） */
export function GET_ReportAnalytics(token, payload) {
  return request.get("/Report/Analytics", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
